module.exports = __webpack_public_path__ + "static/NAL-e9452aed978a4e54fbb13944003e79fb.png";